import {
  useAlertContext,
  useCancelRequests,
  useDocumentTitle,
} from '../common';
import { RequestStatus } from '../request-status';
import { Container } from '@mui/material';
import { useGetStatusMemberRequests } from '.';
import { useEffect, useState } from 'react';
import config from '../config.json';
import { noop, flow } from 'lodash/fp';

export function RequestStatusTeam() {
  useDocumentTitle({ title: 'Status of Member Requests' });

  const [selectedRequestIds, setSelectedRequestIds] = useState<number[]>([]);

  const toggleRequestSelection = (payload: any) => {
    const index = selectedRequestIds.indexOf(payload.requestId);
    if (index > -1) {
      let updatedIds = selectedRequestIds.filter(
        requestId => requestId !== payload.requestId
      );
      setSelectedRequestIds(updatedIds);
    } else {
      setSelectedRequestIds([...selectedRequestIds, payload.requestId]);
    }
  };

  const clearRequestSelection = () => setSelectedRequestIds([]);

  const { cancelRequestsStatus, cancelRequests, resetCancelRequests } =
    useCancelRequests({
      requestIds: selectedRequestIds,
      admin: false
    });

  const { setAlert } = useAlertContext();

  const confirmCancelRequests = () =>
    setAlert(a => ({
      ...a,
      title: 'CSOS',
      message: () => <>{config.requestCancelConfirm}</>,
      okAction: true,
      cancelAction: true,
      isOpen: true,
      isOk: false,
      onOk: cancelRequests,
    }));

  const { apiCallStatus, requests, reload } = useGetStatusMemberRequests();

  useEffect(() => {
    const clearAlert = () =>
      setAlert(a => ({
        ...a,
        isOk: false,
        isOpen: false,
      }));

    cancelRequestsStatus === null &&
      setAlert(a => ({
        ...a,
        title: 'CSOS Canceling Requests',
        message: () => <>{config.requestCanceling}</>,
        okAction: false,
        cancelAction: false,
        isOpen: true,
        onOk: noop,
      }));

    cancelRequestsStatus === false &&
      setAlert(a => ({
        ...a,
        title: 'CSOS Failure',
        message: () => <>{config.requestCancelFailure}</>,
        okAction: true,
        cancelAction: false,
        isOpen: true,
        onOk: flow(clearAlert, resetCancelRequests),
      }));

    cancelRequestsStatus === true &&
      flow(
        () => {
          const newAlert = {
            title: 'CSOS Success',
            message: () => <>{config.requestCancelSuccess}</>,
            okAction: true,
            cancelAction: false,
            isOpen: true,
            onOk: flow(clearAlert, resetCancelRequests),
          };
          setAlert(a => ({
            ...a,
            ...newAlert,
          }));
        },
        reload,
        clearRequestSelection
      )();
  }, [cancelRequestsStatus, reload, setAlert, resetCancelRequests]);

  switch (apiCallStatus) {
    case null:
      return <Container maxWidth="lg">Loading...</Container>;

    case false:
      return <Container maxWidth="lg">Error</Container>;

    case true:
      return (
        <RequestStatus
          requestStatusType="MemberRequestStatus"
          requests={requests}
          toggleRequestSelection={toggleRequestSelection}
          selectedRequests={requests.filter(request =>
            selectedRequestIds.includes(request.requestId)
          )}
          confirmCancelRequests={confirmCancelRequests}
        />
      );

    case void 0:
      return null;

    default:
      return <Container maxWidth="lg">Idk</Container>;
  }
}
